
export interface CoreScheduleSyncGoogleConfiguration {
    id: string
    resourceMode: GoogleScheduleEventResourceMode
    includeMeetLink: boolean
    eventVisibility: GoogleScheduleEventVisibility
}

export enum GoogleScheduleEventResourceMode {
    Undefined = 0,
    NoResources = 1,
    Strict = 2,
    Permissive = 3,
}

export enum GoogleScheduleEventVisibility {
    Default = 0,
    Public = 1,
    Private = 2,
}
